import React from "react";

const Subjective: React.FC = () => {
  return <div>Subjective Content</div>;
};

export default Subjective;
